<template>
  <div class="ml-imp-step-1">
    <el-upload
      :before-upload="beforeUpload"
      :http-request="uploadExcel"
      :show-file-list="false"
      accept=".xls,.xlsx"
      class="upload-record"
      drag
      action=""
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div slot="tip" class="el-upload__tip">
        只能上传 xlsx / xls 文件，且不超过50M
        <div style="margin-top: 20px;">
          <ml-export-static :data="[]" link text="点击下载导入模板" :module="`${module}_IMPORT_TEMPLATE`" />
        </div>
      </div>
    </el-upload>

    <div class="footer">
      <el-button size="medium" plain>取消</el-button>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'xlsx'
import MlExportStatic from '@/components/MlExportStatic/index.vue'
import { module_config } from '@/components/MlExportStatic'

export default {
  name: 'MlImportStep1',
  components: { MlExportStatic },
  props: {
    module: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    beforeUpload(file) {
      this.loading = true
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('导入文件大小不能超过 10MB!')
        this.loading = false
      }
      return isLt2M
    },
    uploadExcel: function({ file }) {
      if (!file) {
        return
      }
      this.file = file
      this.loading = true
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const workbook = XLSX.read(data, { type: 'binary', codepage: 936 })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const json = XLSX.utils.sheet_to_json(worksheet, { range: 0 })
        this.dealJson(json)
        setTimeout(() => {
          this.loading = false
        }, 100)
      }
      reader.readAsBinaryString(file)
    },
    dealJson: function(json) {
      this.loading = true

      const map = module_config[`${this.module}_IMPORT_TEMPLATE`].fields
      const collection = []
      if (Array.isArray(json)) {
        json.map(_ => {
          const obj = { doing: false, do_error: null, do_status: 'wait', do_status_alia: '等待', do_remark_alia: '' }
          for (const x in _) {
            obj[map[x]] = _[x]
          }
          // this.dealRow(obj)
          collection.push(obj)
        })
      }

      this.$emit('success', collection)
    },
    dealRow: function() {
    }

  }
}
</script>
<style lang="scss">
.ml-imp-step-1 {
  height: calc(100vh - 180px);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
